import Tooltip from 'bootstrap/js/dist/tooltip';

/**
 * Initialize policy forms filtering and tooltips.
 */
const initializePolicyFormsLists = function () {
  document.querySelectorAll('.policies-forms-list').forEach(function (block) {
    const buttons = block.querySelectorAll('[data-forms-filter]');

    const groups = block.querySelectorAll('[data-forms-group]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const selectedFilter = (button.dataset.formsFilter || '').toLowerCase();

        buttons.forEach(function (otherButton) {
          const isSelected = otherButton === button;

          otherButton.classList.toggle('btn-primary', isSelected);

          otherButton.classList.toggle('btn-outline-primary', !isSelected);

          otherButton.setAttribute(
            'aria-pressed',
            isSelected ? 'true' : 'false'
          );
        });

        groups.forEach(function (group) {
          const groupName = (group.dataset.formsGroup || '').toLowerCase();

          const groupType = (group.dataset.formsType || '').toLowerCase();

          let shouldShow = false;

          if (selectedFilter === 'all') {
            shouldShow = true;
          } else if (selectedFilter === '0-9') {
            shouldShow = groupType === 'numeric';
          } else {
            shouldShow = groupName === selectedFilter;
          }

          group.hidden = !shouldShow;
        });

        const tooltip = Tooltip.getInstance(button);

        if (tooltip) {
          tooltip.hide();
        }

        button.blur();
      });
    });

    block
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach(function (element) {
        const existingTooltip = Tooltip.getInstance(element);

        if (existingTooltip) {
          existingTooltip.dispose();
        }

        const tooltip = new Tooltip(element, {
          trigger: 'manual',
        });

        element.addEventListener('mouseenter', function () {
          tooltip.show();
        });

        element.addEventListener('mouseleave', function () {
          tooltip.hide();
        });

        element.addEventListener('click', function () {
          tooltip.hide();
        });
      });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePolicyFormsLists);
} else {
  initializePolicyFormsLists();
}
